export default __webpack_public_path__ + "static/media/tos_symbol.c49a6cf2.svg";